<template>
  <input
    :value="modelValue"
    class="form-control input"
    :placeholder="$t(placeholder)"
    :required="required"
    :name="name"
    :autocomplete="noAutocomplete ? 'off' : 'on'"
    type="input"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>

<script>
/**
 * This component works as the base for a simple input string.
 * It works well with both blade forms and vue components and allows for v-model to be used with it.
 */
export default {
  name: 'BaseInputText',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    noAutocomplete: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
}
</script>

<style scoped lang="scss">
.required-asterix {
  position: inherit;
  top: 5px;
}

.base-input {
  width: 100%;
  display: inline-block;
}
</style>
